import Vue from 'vue'
import { CODEBUG } from '@hub/codebug'

let codebug = null

const PROD = window.env === 'PROD'
codebug = new CODEBUG({
    APPID: 'af5b334e-e5e4-47a9-8940-057000093b63',
    ENV: PROD ? 'PROD' : 'ALPHA',
    VERSION: window.ft || window.it || new Date().getTime(),
    extensions: {
        channelCode: 'OWF_MOBILE',
        sceneCode: ''
    }
})
Vue.use(codebug.vueErrorHandler.bind(codebug))

export const CBG = {
    addCBGReport(customId = '', customName = '', options = {}) {
        if (!codebug) {
            return
        }
        codebug.report(customId, customName, options)
    },
    addCBGEventTrack(eventId = '', eventName = '', finalAttributes = {}) {
        if (!codebug) {
            return
        }
        codebug.gather(eventId, eventName, finalAttributes)
    },
    setExtensions(options) {
        if (!codebug) {
            return
        }
        codebug.setExtensions(options)
    }
}

const codebugPlugin = {
    install(Vue) {
        Vue.prototype.$addCBGReport = CBG.addCBGReport
        Vue.prototype.$addCBGEventTrack = CBG.addCBGEventTrack
        Vue.prototype.$setExtensions = CBG.setExtensions
    }
}

export default codebugPlugin



// WEBPACK FOOTER //
// ./src/util/codebug.js